var AngularConstraint = require('./constraints/AngularConstraint');
var AxisConstraint = require('./constraints/AxisConstraint');
var CircularConstraint = require('./constraints/CircularConstraint');
var MaxConstraint = require('./constraints/MaxConstraint');
var MinConstraint = require('./constraints/MinConstraint');
var RectConstraint = require('./constraints/RectConstraint');
    /** @module toxi/physics2d/constraints */
	exports.AngularConstraint = AngularConstraint;
	exports.AxisConstraint = AxisConstraint;
	exports.CircularConstraint = CircularConstraint;
	exports.MaxConstraint = MaxConstraint;
	exports.MinConstraint = MinConstraint;
	exports.RectConstraint = RectConstraint;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/physics2d/constraints.js
// module id = 4642
// module chunks = 15